import { gql } from '@apollo/client';
import { CAR_DETAIL_FRAGMENT } from '../../../common/graphqlQueries/fragments';

export const GET_INVENTORY_LIST_V3 = gql`
  query getInventoryList($page: Int, $search: String, $orderBy: String, $filters: [FilterInputType!], $workshopId: String!, $extraData: [String!]) {
    getInventory(page: $page, search: $search, orderBy: $orderBy, filters: $filters, workshopId: $workshopId, extraData: $extraData) {
      data {
        id
        orderId
        car {
          ...CarDetail
        }
        hubMetaData
        refurbCategory
        statusDisplay: refurbCarStatus {
          label
          color
        }
        assignedTo {
          id
          workshop {
            id
            name
            displayName
          }
          user {
            id
            fullName
          }
        }
        customer {
          id
          name
          displayName
        }
        jobList{
          id
          inspectionStatus
        }
        isInspectorEditable
        isSoftAssigned
        createdAt
        workshop {
          id
        }
      }
      orderBy
      filters {
        key
      }
      paginator {
        totalItems
        perPage
        numPages
        currentPage
      }
    }
  }
  ${CAR_DETAIL_FRAGMENT}
`;

export const GET_INSPECTOR_LIST = gql`
  query getInspectorList($workshopId: String!) {
    getInspectors(workshopId: $workshopId) {
      id
      fullName
    }
  }
`;

export const ASSIGN_INSPECTOR = gql`
  mutation assignInspector($refurbCarId: String!, $inspectorId: String!) {
    assignInspector(data: { inventoryId: $refurbCarId, inspectorId: $inspectorId }) {
      ok
      messages
      refurbCar {
        id
        status
        statusDisplay
        isInspectorAssignable
        assignedDate
        joblistAssignmentTime
        i3CompletionStatus {
          label
          color
        }
        i3AssignmentStatus {
          label
          color
        }
        joblistAssignmentStatus {
          label
          color
        }
        refurbCompletionStatus {
          label
          color
        }
        i3StartStatus {
          label
          color
        }
        inspectorAssigned {
          id
          fullName
        }
      }
    }
  }
`;

export const GET_AVAILABLE_CGTS = gql`
  query getAvailableWorkshopCgtForMake($assignedWorkshopId: String!, $make: String!) {
    getAvailableWorkshopCgtForMake(workshopId: $assignedWorkshopId, make: $make) {
      id
      user {
        id
        fullName
      }
      score
      userCapacity {
        availableCapacity
        maxCapacity
      }
    }
  }
`;

export const GET_POD_LISTING = gql`
    query getPodListingForWorkshop($workshopId: String!) {
        getPodListingForWorkshop(workshopId: $workshopId) {
            podValue
            name
        }
    }
`;

export const ADD_CAR_CHILD_WORKSHOPS = gql`
  query getChildWorkshops($workshopId: String!) {
    getChildWorkshops(parentWorkshopId: $workshopId) {
      id
      displayName
      name
      state
    }
  }
`;

export const GET_CUSTOMER_LIST_V3 = gql`
    query CustomerList{
        customerList{
            id
            displayName
        }
    }
`;

export const GET_ADVISORS_FOR_WORKSHOP_V3 = gql`
    query getAdvisorsForWorkshop($workshopIds: [String!], $flatList: Boolean) {
        getAdvisorsForWorkshop(workshopIds: $workshopIds, flatList: $flatList){
            id
            fullName
        }
    }
`;

export const GET_TIMELINE = gql`
  query getRefurbCarTimelines($refurbCarId: String, $workshopId: String!) {
    getRefurbCarTimelines(refurbCarId: $refurbCarId, workshopId: $workshopId) {
      journeyTime
      journeyText
      label
      color
    }
  }
`;
